import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { EMPTY, Observable, of, throwError } from 'rxjs';
import { catchError, expand, filter, map, reduce, tap } from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import { FlavorResponse, Location, Shift } from '../models/flavor.model';

@Injectable({
    providedIn: 'root',
})
export class OrderWithFlavorService {

    constructor(
        private http: HttpClient,
    ){}

    public getLocations(deployment:string): Observable<Location[]> {
        return this.http.get(environment.apiUrl + `flavor/locations/${deployment}`).pipe(
            map((response: FlavorResponse<Location>) => response.results), 
            catchError(this.handleError)
        );
    }

    public getShifts(deployment: string, startDate: Date, endDate: Date, locationId?: string, shiftId?: string): Observable<Shift[]> {
        const start = startDate || new Date();
        const localDateString = `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, '0')}-${String(start.getDate()).padStart(2, '0')}`;

        const end = endDate || new Date(start.getTime() + 14 * 24 * 60 * 60 * 1000); // Default to 14 days if no endDate
        const lteDateString = `${end.getFullYear()}-${String(end.getMonth() + 1).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')}`;
        const limit = 40;
        const offset = 0;
        const buildUrl = (currentOffset: number) => {
            let url = `${environment.apiUrl}flavor/shifts/${deployment}?dayGte=${localDateString}&includePopupMarketing=true&isPublic=true&limit=${limit}&offset=${currentOffset}`;
            if (locationId) {
                url += `&locationId=${locationId}`;
            }
            if (shiftId) {
                url += `&shiftId=${shiftId}`
            } else {
                url += `&dayLte=${lteDateString}`
            }
            return url;
        };

        return this.paginatedShiftRequest(buildUrl, limit, offset).pipe(
            reduce((all: Shift[], resp) => all.concat(resp.results), []),
            catchError(this.handleError)
        );
    }

    private paginatedShiftRequest(
        buildUrl: (offset: number) => string,
        limit: number,
        offset: number
    ): Observable<FlavorResponse<Shift>> {
        return this.http.get<FlavorResponse<Shift>>(buildUrl(offset)).pipe(
            expand((response, i) => {
                const nextOffset = (i + 1) * limit;
    
                if (response.results.length < limit || nextOffset > 500) {
                    return EMPTY;
                }
    
                return this.http.get<FlavorResponse<Shift>>(buildUrl(nextOffset));
            })
        );
    } 
    

    private handleError(error: any) {
        console.error(error);
        return throwError(() => error);
      }
}